import * as React from 'react';

import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';

import l10n from '../../util/l10n';

interface CKEditorFormatMenuProps extends React.Props<CKEditorFormatMenu> {
    ckEditor: CKEditor;
}

interface CKEditorFormatMenuState {
    format: string;
}

export default class CKEditorFormatMenu
extends React.Component<CKEditorFormatMenuProps, CKEditorFormatMenuState> {

    private styles: any;
    private formats: string[];

    constructor(props: CKEditorFormatMenuProps) {
        super(props);

        const { ckEditor } = this.props;

        this.buildStyles(ckEditor);

        const startElement = ckEditor.getSelection().getStartElement();
        const path = ckEditor.elementPath(startElement);
        const matchingFormat = this.getMatchingFormat(path);

        this.state = { format: matchingFormat };
    }

    componentDidMount() {
        this.props.ckEditor.on('selectionChange', this.onSelectionChange);
    }

    componentWillUnmount() {
        this.props.ckEditor.removeListener('selectionChange', this.onSelectionChange);
    }

    render() {
        const styles = this.getStyles();

        return (
            <DropDownMenu
                value={this.state.format}
                // XXX not using onChange because it may be triggered async, outside of event loop
                // and touch devices don't like this and will not focus ckEditor
                // using onTouchTap on MenuItem instead
                // onChange={this.onChange}
                style={styles.root}
                data-test-id="text-module-heading-menu"
            >
                {this.formats.map( (format, index) =>
                    <MenuItem value={format} primaryText={l10n(`module.text.format.${format}`)} key={index}
                        onTouchTap={(e: React.SyntheticEvent<{}>) => {this.onChange(e, index, format);}}
                        />
                )}
            </DropDownMenu>
        );
    }

    private buildStyles(ckEditor: any) {
        const entries = ckEditor.config.format_tags;
        const parts = entries.split(';');

        this.styles = {};
        this.formats = [];

        for (let index = 0; index < parts.length; ++index) {
            const tag = parts[index];

            const style = new CKEDITOR.style(ckEditor.config[`format_${tag}`]);
            style._.enterMode = ckEditor.config.enterMode;
            this.styles[tag] = style;

            this.formats.push(tag);
        }
    }

    private getMatchingFormat(path: any): string {
        let matchingFormat = this.formats[0];

        for (const tag in this.styles) {
            if (this.styles.hasOwnProperty(tag)) {
                if (this.styles[tag].checkActive(path) ) {
                    matchingFormat = tag;
                }
            }
        }

        return matchingFormat;
    }

    private onSelectionChange = (event: any) => {
        const path = event.data.path;
        const matchingFormat = this.getMatchingFormat(path);

        if (this.state.format !== matchingFormat) {
            const newState = {} as CKEditorFormatMenuState;
            newState.format = matchingFormat;
            this.setState(newState);
        }
    };

    private onChange = (event: React.SyntheticEvent<{}>, index: number, format: string) => {
        // prevent ghost click events on touch devices
        event.preventDefault();
        const { ckEditor } = this.props;
        ckEditor.focus();

        ckEditor.fire( 'saveSnapshot' );
        ckEditor.applyStyle(this.styles[format]);
        ckEditor.fire( 'saveSnapshot' );
    };

    private getStyles() {
        return {
            root: {
                width: 200,
                float: 'left',
                overflow: 'hidden'
            }
        };
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/ckeditor/CKEditorFormatMenu.tsx
 **/